<template>
  <div>
    <div class="content-title">
      <span>新增供应商</span>
      <el-button type="primary" @click="addPlatformVisible = true" style="float: right; margin-right: 20px;">新增平台</el-button>
    </div>
    <div class="content-tool"  style="width: 560px;">
      <el-form ref="form" :model="addProviderData" label-width="160px">
        <el-form-item label="供应商名称：">
          <el-input v-model="addProviderData.providerName"></el-input>
        </el-form-item>
        <el-form-item label="服务费率：">
          <el-input-number v-model="addProviderData.serviceRate" :precision="2" :min="0" :max="10000"></el-input-number>
          <span style="font-size: 13px; margin-left: 10px;">( 转账一万元收服务费多少元 )</span>
        </el-form-item>
        <el-form-item label="公司对公账号：">
          <el-input v-model="addProviderData.bankAccount"></el-input>
        </el-form-item>
        <el-form-item label="开户行：">
          <el-input v-model="addProviderData.bankAccountName"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号：">
          <el-input v-model="addProviderData.taxpayerIDNumber"></el-input>
        </el-form-item>
        <el-form-item label="是否扣除所得税：">
          <el-switch v-model="addProviderData.isPersonalTax" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
        <el-form-item label="每月转账限额（元）：">
          <el-input v-model="addProviderData.userMonthPayLimit"></el-input>
        </el-form-item>
        <el-form-item label="联系人：">
          <el-input v-model="addProviderData.contactUser"></el-input>
        </el-form-item>
        <el-form-item label="电话：">
          <el-input v-model="addProviderData.phone"></el-input>
        </el-form-item>
        <el-form-item label="地址：">
          <el-input v-model="addProviderData.address"></el-input>
        </el-form-item>
        <el-form-item label="所属平台：">
          <el-select multiple v-model="addProviderData.platformIds">
            <el-option v-for="p in platforms" :key="p.platformId" :label="p.platformName" :value="p.platformId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addProvider">保存</el-button>
          <el-button @click="addProviderVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="新增平台" width="600px" :visible.sync="addPlatformVisible" append-to-body>
      <el-form ref="form" :model="addPlatformData" label-width="120px">
        <el-form-item label="新增平台名称：">
          <el-input v-model="addPlatformData.platformName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addPlatform">保存</el-button>
          <el-button @click="addPlatformVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/api';
// import { Loading } from 'element-ui';
// import { passwdHmacSHA1 } from '@/utils';

export default {
  name: 'addprovider',
  data() {
    return {
      providerPlatforms: [],
      platforms: [],
      providers: [],
      addPlatformVisible: false,
      addPlatformData: {
        platformName: null,
      },
      addProviderData: {
        providerName: null,
        platformIds: null,
        serviceRate: 0.0,
        bankAccount: null,
        bankAccountName: null,
        taxpayerIDNumber: null,
        userMonthPayLimit: 92000,
        contactUser: null,
        phone: null,
        address: null,
        isPersonalTax: 0,
      },
    };
  },
  mounted() {
    this.fetchPlatforms();
  },
  methods: {
    fetchPlatforms() {
      api.fetchPlatforms().then((res) => {
        console.log(res);
        if (!res) {
          return;
        }
        this.platforms = res;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    addPlatform() {
      api.addPlatform({
        params: {
          data: this.addPlatformData,
        },
      }).then(() => {
        this.addPlatformVisible = false;
        this.$message({
          type: 'success',
          message: '新增成功',
        });
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    addProvider() {
      this.addProviderData.isPersonalTax = this.addProviderData.isPersonalTax ? 1 : 0;
      api.addProvider({
        params: {
          data: this.addProviderData,
        },
      }).then(() => {
        this.addProviderVisible = false;
        this.$message({
          type: 'success',
          message: '新增成功',
        });
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    fetchPlatformsByProviderId() {
      api.fetchPlatformsByProviderId({
        params: {
          params: {
            providerId: this.addaccount.providerId,
          },
        },
      }).then((res) => {
        console.log(res);
        if (!res) {
          return;
        }
        this.providerPlatforms = res;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>

.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-title {
  font-size: 18px;
  margin: 10px 20px 20px 20px;
}

.content-tool {
  // padding: 27px 17px 20px 17px;
  // border: 1px solid #ebeef5;
  background: #fff;
  font-size: 15px;
  color: #606266;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 30%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
    padding: 0px 17px 20px 17px;
    margin: 0px 20px 20px 20px;
  }
.content-search-title {
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 30px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-name-txt {
    color: #20a0ff;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/addprovider.vue